import { Link } from "gatsby"
import { getImage, GatsbyImage, StaticImage } from "gatsby-plugin-image"
import * as React from "react"
import { BOOKING } from "../../utils/constants"
import formatPrice from "../../utils/priceFormatter"
import Fade from "react-reveal/Fade"

const YachtIntro = ({ yachtData }) => {
    return (
        <div className="container-xxl position-relative">
            {/* <StaticImage className="background-yacht-water d-none d-md-block" src="../images/water1.png" alt="water" /> */}
            <div className="row yacht-container">
                <div className="col-12 px-0 col-md-6  ps-inside">
                    <div className="reveal-relative">
                        <Fade right>
                            <GatsbyImage
                                className="overlay-our-yachts-yacht-one mt-md-0 mt-4"
                                image={getImage(yachtData.mainImage)}
                                alt="Yacht image"
                            />
                        </Fade>
                    </div>
                    <StaticImage className="our-yacht-water d-md-none" src="../images/water1.png" alt="water" />
                </div>
                <Fade delay={700} duration={1500}>
                    <div className="col-12  col-md-6  order- pe-inside z-index-1 d-flex flex-column align-items-start justify-content-center">
                        <h2 className="yacht-name">{yachtData.name}</h2>
                        <div className="mt-md-4 mt-3 mb-3">
                            <span className="pre-title">{yachtData.model}</span>
                        </div>
                        {BOOKING && (
                            <>
                                {yachtData?.lowestPrice && (
                                    <span className="pre-title fw-bold bg-white d-inline-block p-1 mb-3">
                                        Experience from €{formatPrice(yachtData?.lowestPrice)}
                                    </span>
                                )}
                                <div>
                                    <Link to="/book" className="button fill light-background me-3 " type="button">
                                        check availibility
                                    </Link>
                                </div>
                            </>
                        )}
                    </div>
                </Fade>
            </div>
        </div>
    )
}

export default YachtIntro
